function getHost(mjpgUrl: string): string {
  const parts: string[] = mjpgUrl.split('//');
  const protocol: string = parts[0];
  const host: string = parts[1].split('/')[0];
  return `${protocol}//${host}`;
}

export default getHost;
